export const successState = 'SUCCESS'
export const failureState = 'FAILURE'
export const pendingState = 'PENDING'
export const progressState = 'PROGRESS'
